import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import assign from 'domkit/appendVendorPrefix';

// constants
import COLORS from 'tstyles/variables.scss';
import { SIZE_TO_VAL, SIZES } from './spinner.sizes';

// Animations
import { animationNameEven, animationNameOdd } from './spinner.animation';
var LOADER_COLOR = COLORS.black;
var ANIMATION_FILL_MODE = 'both';
var Loader = /*#__PURE__*/function (_PureComponent) {
  _inherits(Loader, _PureComponent);
  var _super = _createSuper(Loader);
  function Loader() {
    var _this;
    _classCallCheck(this, Loader);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "getAnimationStyle", function (i) {
      var animation = [i % 2 === 0 ? animationNameEven : animationNameOdd, '1s', '0s', 'infinite', 'cubic-bezier(.15,.46,.9,.6)'].join(' ');
      return {
        animation: animation,
        animationFillMode: ANIMATION_FILL_MODE
      };
    });
    _defineProperty(_assertThisInitialized(_this), "getStyle", function (i) {
      return assign(_this.getBallStyle(), _this.getAnimationStyle(i), {
        display: 'inline-block'
      });
    });
    return _this;
  }
  _createClass(Loader, [{
    key: "getBallStyle",
    value: function getBallStyle() {
      var _this$props = this.props,
        size = _this$props.size,
        margin = _this$props.margin,
        verticalAlign = _this$props.verticalAlign;
      var sizeVal = SIZE_TO_VAL[size];
      return {
        backgroundColor: LOADER_COLOR,
        width: sizeVal,
        height: sizeVal,
        margin: margin,
        borderRadius: '100%',
        verticalAlign: verticalAlign
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        loading = _this$props2.loading,
        id = _this$props2.id,
        className = _this$props2.className;
      if (loading) {
        return /*#__PURE__*/React.createElement("div", {
          id: id,
          className: className
        }, /*#__PURE__*/React.createElement("div", {
          style: this.getStyle(1)
        }), /*#__PURE__*/React.createElement("div", {
          style: this.getStyle(2)
        }), /*#__PURE__*/React.createElement("div", {
          style: this.getStyle(3)
        }), /*#__PURE__*/React.createElement("div", {
          style: this.getStyle(4)
        }), /*#__PURE__*/React.createElement("div", {
          style: this.getStyle(5)
        }));
      }
      return null;
    }
  }]);
  return Loader;
}(PureComponent);
Loader.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  margin: PropTypes.string,
  size: PropTypes.string,
  verticalAlign: PropTypes.string
};
Loader.defaultProps = {
  className: '',
  loading: true,
  margin: '2px',
  size: SIZES.MEDIUM,
  verticalAlign: undefined
};
export default Loader;